import { defaultJobCustomerState } from "../../redux/job_customer";
import { IBillingCompanyContextState } from "./BillingCompanyProvider.types";

export const defaultBillingCompanyContextState: IBillingCompanyContextState = {
  comapny: defaultJobCustomerState["customer"]["data"],
};
